import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import useLocalizedFormattedText from '@frolight/hooks/useLocalizedFormattedText';

const ApplicationFooter = ({ compact = false, theme = 'light' } = {}) => {
  const { lftext } = useLocalizedFormattedText();

  const getLinkClass = (isActive) => {
    let classes = 'link_bar__link';
    if (isActive) classes += '  link_bar__link--active';
    return classes;
  };

  return (
    <footer className={ `application_footer  application_footer--${theme}${compact ? '  application_footer--compact' : null}` }>
      <div className="application_footer__inner">
        <div className="application_footer__copyright">
          <small>{lftext('components.footer.copyright')}</small>
        </div>
        <div className="application_footer__legal_links">
          <nav
            className="footer_link_list"
            aria-label="Legal mentions"
          >
            <div className="footer_link_list__list">
              <ul className={ `link_bar  link_bar--${theme}` }>
                <li className="link_bar__item">
                  <NavLink
                    className={ ({ isActive }) => getLinkClass(isActive) }
                    to="/legal/terms-of-use"
                  >
                    {lftext('components.footer.terms_of_use')}
                  </NavLink>
                </li>
                <li className="link_bar__item">
                  <NavLink
                    className={ ({ isActive }) => getLinkClass(isActive) }
                    to="/legal/privacy-policy"
                  >
                    {lftext('components.footer.privacy_policy')}
                  </NavLink>
                </li>
                <li className="link_bar__item">
                  <NavLink
                    className={ ({ isActive }) => getLinkClass(isActive) }
                    to="/legal/cookie-policy"
                  >
                    {lftext('components.footer.cookie_policy')}
                  </NavLink>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </footer>
  )

};

ApplicationFooter.propTypes = {
  compact: PropTypes.bool,
  theme: PropTypes.oneOf(['light', 'dark'])
};

export default ApplicationFooter;
